import React, { useEffect, useState } from "react";
import { API_URL, authFetch } from "../../utils/auth";

export default function RecentNotifications() {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    async function load() {
      try {
        const res = await authFetch(`${API_URL}/partner/notifications/recent/`);
        const data = await res.json();

        setNotifications(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error(err);
      }
    }

    load();
  }, []);

  return (
    <div className="card">
      <div className="card-title">Recent Notifications</div>

      <div className="list">
        {notifications.length === 0 ? (
          <p className="text-muted">No notifications yet</p>
        ) : (
          notifications.map((n) => (
            <p key={n.id}>
              {n.title}
            </p>
          ))
        )}
      </div>
    </div>
  );
}